import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../components/styled/Text';
import { colors } from '../constants';
import { AiOutlineCheck } from 'react-icons/ai';
import { useOutsideClick } from 'hooks/useOutsideClick';

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledDropDown = styled.div`
  max-height: 160px;
  overflow: auto;
  background-color: ${colors.white};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  ${props => props.direction}: 40px;
  right: ${props => props.right}px;
  box-shadow: 0px 6px 12px 0px ${colors.navy}12;
`;

const StyledDropDownItem = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  background-color: ${colors.white};
  white-space: nowrap;
  svg {
    margin-right: 8px;
  }
  :hover {
    background-color: ${colors.grey90};
  }
`;

const DropDown = ({
  items,
  show,
  children,
  direction,
  onOutsideClick,
  right,
}) => {
  const dropDownRef = useRef();

  useOutsideClick(dropDownRef, onOutsideClick, show);

  return (
    <StyledContainer>
      {children}
      {show && (
        <StyledDropDown direction={direction} ref={dropDownRef} right={right}>
          {items?.map((item, index) => (
            <StyledDropDownItem key={index} onClick={item.onClick}>
              {item.isChosen && <AiOutlineCheck fill={colors.green} />}
              {item.icon}
              <Text color={item.color} variant="body">
                {item.text}
              </Text>
            </StyledDropDownItem>
          ))}
        </StyledDropDown>
      )}
    </StyledContainer>
  );
};

DropDown.propTypes = {
  items: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(['top', 'bottom']),
  onOutsideClick: PropTypes.func,
  right: PropTypes.number,
};

DropDown.defaultProps = {
  direction: 'top',
  onOutsideClick: () => {},
  right: 0,
};

export default DropDown;
